import React, { useEffect } from 'react';
import { Card, ErrorMessage, Grid } from 'ui-toolkit';
import { useAppDispatch } from '../../../store/store';
import { getClientOrderCommentsAction } from '../../../store/clientPortal/clientOrderComments/clientOrderCommentsSlice';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../types/shared/UUID';
import { useKeyToSelect } from '../../../store/createKeyedDataAsyncSlice';
import { RootStore } from '../../../store/types';
import { AddNewCommentForm } from '../../../components/clientPortal/orderOverview/AddNewCommentForm';
import {
  postClientOrderCommentAction,
  postClientOrderCommentSlice,
} from '../../../store/clientPortal/clientOrderComments/clientPostOrderCommentSlice';
import { CommentsView } from '../../../components/clientPortal/orderOverview/CommentsView';
import { ICommentCreateRequest } from '../../../API/order/comments/Comments';

export const ClientCommentsContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const { orderId } = useParams<{ orderId: UUID }>();

  useEffect(() => {
    dispatch(getClientOrderCommentsAction(orderId));
  }, [dispatch, orderId]);

  const onSubmit = async (values: ICommentCreateRequest) => {
    await dispatch(postClientOrderCommentAction({ orderId, newComment: values }));
    await dispatch(getClientOrderCommentsAction(orderId));
    dispatch(postClientOrderCommentSlice.actions.reset({}));
  };

  const onCancel = () => {
    dispatch(postClientOrderCommentSlice.actions.reset({}));
  };

  const { data: comments, fetchError: getCommentsFetchError } = useKeyToSelect(
    orderId,
    (store: RootStore) => store.clientPortal.clientOrderComments,
    []
  );

  const { fetchError: postCommentFetchError } = useKeyToSelect(
    orderId,
    (store: RootStore) => store.clientPortal.clientPostOrderComment
  );

  //TODO: lender initials.
  return (
    <Card title={'Comments'}>
      <Grid>
        <ErrorMessage message={(getCommentsFetchError ?? postCommentFetchError)?.message} />
        <AddNewCommentForm lenderInitials={''} onCancel={onCancel} onSubmit={onSubmit} orderId={orderId} />
        <CommentsView comments={comments} />
      </Grid>
    </Card>
  );
};
